// module factories are used so entry inlining is disabled
// startup
// Load entry module
__webpack_require__(3123);
